import { createElement, type CSSProperties } from 'react'
import type { IconType } from 'react-icons'
import {
  LuActivity,
  LuBell,
  LuBrain,
  LuBuilding,
  LuCalculator,
  LuCalendarCheck,
  LuChartColumn,
  LuCircleCheck,
  LuClipboardCheck,
  LuClock,
  LuCoins,
  LuComponent,
  LuContact,
  LuDatabase,
  LuEye,
  LuFactory,
  LuFileCheck,
  LuFileSearch,
  LuFileText,
  LuFingerprint,
  LuFlaskConical,
  LuFolderOpen,
  LuGem,
  LuGlobe,
  LuHourglass,
  LuLayers,
  LuLayoutDashboard,
  LuMap,
  LuMapPin,
  LuMountain,
  LuPackage,
  LuPause,
  LuRadar,
  LuReceipt,
  LuRoute,
  LuRuler,
  LuScale,
  LuScanLine,
  LuScrollText,
  LuSettings,
  LuShield,
  LuShieldCheck,
  LuSiren,
  LuTrendingUp,
  LuTriangleAlert,
  LuTruck,
  LuUserPlus,
  LuUsers,
} from 'react-icons/lu'

const ICONS: Record<string, IconType> = {
  LuActivity,
  LuBell,
  LuBrain,
  LuBuilding,
  LuCalculator,
  LuCalendarCheck,
  LuChartColumn,
  LuCircleCheck,
  LuClipboardCheck,
  LuClock,
  LuCoins,
  LuComponent,
  LuContact,
  LuDatabase,
  LuEye,
  LuFactory,
  LuFileCheck,
  LuFileSearch,
  LuFileText,
  LuFingerprint,
  LuFlaskConical,
  LuFolderOpen,
  LuGem,
  LuGlobe,
  LuHourglass,
  LuLayers,
  LuLayoutDashboard,
  LuMap,
  LuMapPin,
  LuMountain,
  LuPackage,
  LuPause,
  LuRadar,
  LuReceipt,
  LuRoute,
  LuRuler,
  LuScale,
  LuScanLine,
  LuScrollText,
  LuSettings,
  LuShield,
  LuShieldCheck,
  LuSiren,
  LuTrendingUp,
  LuTriangleAlert,
  LuTruck,
  LuUserPlus,
  LuUsers,
}

// eslint-disable-next-line react-refresh/only-export-components
export function resolveIcon(name: string | null | undefined): IconType {
  if (!name) return LuLayoutDashboard
  return ICONS[name] ?? LuLayoutDashboard
}

/** Sorted list of every icon name registered above — used by the menu
 *  editor's visual icon picker. Keeps the picker grid in sync with the
 *  runtime registry: an icon usable in the sidebar is pickable here, and
 *  vice-versa. */
// eslint-disable-next-line react-refresh/only-export-components
export const iconNames: string[] = Object.keys(ICONS).sort()

interface MenuIconProps {
  name: string | null | undefined
  size?: number
  color?: string
  style?: CSSProperties
}

export function MenuIcon({ name, size, color, style }: MenuIconProps) {
  // Dynamic icon lookup is the whole point of this component. createElement
  // sidesteps the "no components created during render" lint rule that would
  // fire on the equivalent <Icon /> JSX.
  return createElement(resolveIcon(name), { size, color, style })
}

